// extracted by mini-css-extract-plugin
module.exports = {"onboardingProgress":"styles_onboardingProgress__inHNL","skipOnboarding":"styles_skipOnboarding__NArKa"};